export default [
  {
    path: '/activity-20260703-main',
    component: () => import('./Page.vue'),
    meta: { title: 'HiFun星声榜', id: 35 },
  },
]
